<template lang="pug">
div(class="tw-rounded-md tw-border tw-border-blueGray-lighten-4 tw-cursor-pointer")
  v-row(no-gutters align="center")
    template(v-if="show_menu")
      v-col(cols="auto")
        v-menu(offset-y nudge-right dark class="tw-mx-0 tw-px-0")
          template(v-slot:activator="{ on, attrs }")
            v-btn(
              @click=""
              v-bind="attrs"
              width="5"
              min-width="5"
              dense
              color="blue-grey"
              plain
              tile
              text
              v-ripple="false"
              v-on="on"
              class=" tw-p-0 k-btn-context"
            )
              v-icon(size="26px" class=" tw-pl-0 tw-mb-0 tw-pr-1 tw-pb-1") mdi-dots-vertical
          v-list(dense)
            v-list-item(class="tw-px-0")
              v-btn(@click="copyLink(item.name)" text block class="my-0")
                v-row(no-gutters class="tw-cursor-pointer")
                  v-col(cols="auto" class="mr-1")
                    v-icon(small color="white") mdi-link
                  v-col(cols="auto")
                    span(class=" tw-text-white tw-font-bold") {{ $t('Common.copyLink') }}
            v-list-item(class="tw-px-0")
              v-btn(@click="update(2)" text block class="my-0")
                v-row(no-gutters class="tw-cursor-pointer")
                  v-col(cols="auto" class="mr-1")
                    v-icon(small color="white") mdi-check-decagram
                  v-col(cols="auto")
                    span(class=" tw-text-white tw-font-bold") {{ $t('Opportunities.Common.considering') }}
            v-list-item(class="tw-px-0")
              v-btn(@click="update(3)" text block class="my-0 py-0")
                v-row(no-gutters class="tw-cursor-pointer")
                  v-col(cols="auto" class="mr-1")
                    v-icon(small color="white") mdi-close-circle
                  v-col(cols="auto")
                    span(class=" tw-text-white tw-font-bold") {{ $t('Opportunities.Common.discard') }}
            v-list-item(class="tw-px-0")
              v-btn(@click="deleteItem(pitch)" text block class="my-0")
                v-row(no-gutters class="tw-cursor-pointer")
                  v-col(cols="auto" class="mr-1")
                    v-icon(small color="white") mdi-trash-can
                  v-col(cols="auto")
                    span(class=" tw-text-white tw-font-bold") {{ $t('Opportunities.Common.discard') }}
    template(v-else)
      v-col(cols="auto")
        div(class="tw-w-6")
    v-col(cols="auto" class=" tw--ml-4  ")
      v-checkbox(
        v-model="selection"
        :value="!pitch ? item.id : pitch.id"
        background-color="#ffffff"
        :ripple="false"
        color=" indigo lighten-2"
        class=""
      )
    v-col(cols="auto")
      template(v-if="item && !loading")
        router-link(class="tw-font-medium text-link" :to="{ name: 'goodsItem', params: { id: item.id } }")
          v-img(
            v-if="typeof item.galleries[0] == 'undefined' || !item.galleries[0].main_image"
            :src="require('@/assets/images/placeholder-image.jpg')"
            aspect-ratio="1.4"
            fill
            width="130px"
          )
          v-img(
            v-else
            :src="path(item.galleries[0].main_image.path)"
            aspect-ratio="1.4"
            fill
            width="130px"
          )
      template(v-else)
        v-img(:src="require('@/assets/images/placeholder-image.jpg')" aspect-ratio="1.4" fill width="130px")
    v-col(class="tw-mx-2")
      template(v-if="item && !loading")
        v-row(no-gutters)
          v-col(class="tw-pt-6 tw-mt-2")
            router-link(class="text-link" :to="{ name: 'goodsItem', params: { id: item.id } }")
              span(class="tw-font-semibold ") {{ item.name }}
        v-row(no-gutters)
          v-col
            router-link(class="text-link" :to="{ name: 'goodsItem', params: { id: item.id } }")
              span(class=" tw-text-sm  ") {{ item.address_street }} {{ item.address_street_number }}, {{ item.address_city }}, {{ item.address_zip_code }}
        v-row(no-gutters align="end" justify="start" class="tw-py-2")
          v-col(cols="auto" class="tw-mr-2")
            v-row(no-gutters align="center" justify="center")
              v-col(cols="auto" class=" tw-text-center tw-text-lg grey--text tw-font-medium")
                span {{ item.bedrooms }}
              v-col(cols="auto" class=" tw-text-center")
                v-icon mdi-bed
            v-row(no-gutters)
              v-col(class=" tw-text-center tw-text-xs tw-capitalize")
                | {{ $t('Listings.Common.bedrooms') }}
          v-col(cols="auto" class="tw-mr-2")
            v-row(no-gutters align="center" justify="center")
              v-col(cols="auto" class=" tw-text-center tw-text-lg grey--text tw-font-medium")
                span {{ item.bathrooms }}
              v-col(cols="auto" class=" tw-text-center")
                v-icon mdi-shower
            v-row(no-gutters)
              v-col(class=" tw-text-center tw-text-xs tw-capitalize")
                | {{ $t('Listings.Common.bathrooms') }}
      template(v-else)
        v-col(class="")
          span(class="tw-font-semibold ") {{ $t('Opportunities.Common.deletedPitch') }}
    v-col(cols="2" class="tw-mx-2")
      template(v-if="show_price")
        v-row(dense align="end")
          v-col(class="tw-text-right tw-mr-1")
            span(class="tw-font-extrabold") ${{ this.$faker().finance.amount(10000, 1000000, 0) }}
      template(v-if="status")
        v-row(dense align="start" justify="end")
          v-col(cols="auto")
            div(
              :class="formatStatus(status).class"
              class=" tw-px-2 tw-text-center tw-py-1 tw-rounded-full tw-bg-green-lighten-3 tw-bg-opacity-75"
            )
              span(class="tw-text-sm tw-font-semibold tw-capitalize tw-text-center") {{ formatStatus(status).text }}
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      default: null,
    },
    status: {
      type: Number,
      default: null,
    },
    show_menu: {
      type: Boolean,
      default: false,
    },
    show_price: {
      type: Boolean,
      default: false,
    },
    pitch: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    selection: {
      get() {
        return this.$store.getters['opportunities/pitches/selection'];
      },
      set(value) {
        return this.$store.commit('opportunities/pitches/SET_SELECTION', value);
      },
    },
    opportunity() {
      return this.$route.params.id;
    },
  },
  methods: {
    formatStatus(s) {
      let status = {};
      switch (s) {
        case 1:
          status.class = 'new';
          status.text = this.$t('Common.new');
          return status;
        case 2:
          status.class = 'considering';
          status.text = this.$t('Opportunities.Common.considering');
          return status;
        case 3:
          status.class = 'discarded';
          status.text = this.$t('Opportunities.Common.discarded');
          return status;
      }
    },
    deleteItem(pitch) {
      let pitches = [];
      pitches.push(pitch);
      return this.$store.dispatch('opportunities/pitches/delete', [this.opportunity, pitches]);
    },
    update(status) {
      let pitches = [];
      this.pitch.status = status;
      pitches.push(this.pitch);
      this.$store.dispatch('opportunities/pitches/update', [this.opportunity, pitches]);
    },
    copyLink() {
      let website = this.$store.getters['team/currentTeam'].website;
      if (website.domain_verified) {
        this.$store.commit('SET_SUCCESS', 'Link copied to clipboard');
        navigator.clipboard.writeText('http://' + website.domain + '/listings/' + this.item.id);
      } else {
        this.$store.commit('SET_SUCCESS', 'Link copied to clipboard');
        navigator.clipboard.writeText('http://' + website.domain + '/listings/' + this.item.id);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.considering {
  @apply tw-bg-green-lighten-4 tw-text-lightGreen-darken-3;
}

.new {
  @apply tw-bg-blue-lighten-4 tw-text-blue-darken-3;
}

.discarded {
  @apply tw-bg-gray-lighten-3 tw-text-gray-darken-2;
}
</style>
